<template>
  <div class="use-table">
    <!--    :row-selection="rowSelection" 'calc(1000px + 50%)'-->
    <a-table
      :columns="tableHeaderModel"
      bordered
      :pagination="false"
      :row-selection="{
        selectedRowKeys: tableSelectArr,
        onSelect: onSelect,
        onSelectAll: onSelectAll
      }"
      rowKey="id"
      :data-source="data"
      :scroll="{ x: scrollX, y: 500 }"
      :scrollToFirstRowOnChange="true"
    >



      <template slot="status" slot-scope="text, record">
        <a
          href="javascript:"
          v-for="item in actionBtnGroup"
          :key="`${item.id}-${item.name}`"
          @click="rowEvent(item.method, text, record)"
        >{{ item.name }}
        </a>
      </template>

      <template slot="footer">
        <use-pagination v-bind="$attrs" v-on="$listeners" />
      </template>
    </a-table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import UsePagination from "@/components/UsePagination.vue";
export default {
  name: "use-table",
  components: {
    UsePagination
  },
  props: {
    scrollX: {
      type: String,
      default: "500"
    },
    data: {
      type: Array,
      default: []
    },
    tableHeaderModel: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      actionBtnGroup: [],
      // loading:false,
      total: 0,
      tableDataArr: [],
      selectRows:[]
    };
  },
  methods: {
    ...mapActions(["getTableSeleted"]),

    rowEvent(method, text, row, num) {

      const obj = { method: method, row: row };
      this.$emit("rowEvent", obj);
    },
    onSelect(record, selected, selectedRows) {
      this.filterSelectedTable(selectedRows);
    },
    onSelectAll(selected, selectedRows) {
      this.filterSelectedTable(selectedRows);
    },
    //获取选中的table
    filterSelectedTable(selectedRows) {
      // this.selectRows = selectedRows;
      //
      // this.$emit("getSelectRows",selectedRows)
      // console.log(selectedRows);
      const getSelected = [];
      for (const key in selectedRows) {
        getSelected.push(selectedRows[key].id);
      }
       this.getTableSeleted(getSelected);
    }
  },
  watch: {
    tableHeaderFileter(val, oldVal) {
      //普通的watch监听
      const actionItem = val.find(item => item.title == "操作");
      this.actionBtnGroup = actionItem ? actionItem.btnArr : [];
      // this.isAuthBtn();
    },
    tableData: {
      handler(n, o) {
        const { result, size } = n;
        this.tableDataArr = result;
        // this.total = size;
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters({
      tableHeaderFileter: "tableHeaderFileter" // getToDo 不是字符串，对应的是getter里面的一个方法名字 然后将这个方法名字重新取一个别名 todosALise
    }),
    ...mapState(["tableData", "loading", "tableSelectArr"]),
    // ...mapState(["tableData", "loading"]),
    // rowSelection() {
    //   return {
    //     onSelect: (record, selected, selectedRows) => {
    //       this.filterSelectedTable(selectedRows);
    //     },
    //     onSelectAll: (selected, selectedRows) => {
    //       this.filterSelectedTable(selectedRows);
    //     }
    //   };
    // }
  },
  mounted() {
    const rowAction = this.tableHeaderModel.find(item => item.title === "操作");
    if (rowAction) {
      this.actionBtnGroup = rowAction.btnArr;
    }
  }
};
</script>

<style scoped lang="less">
.use-table {
  /deep/ .ant-table {
    .ant-table-footer {
      text-align: right !important;
    }

    .operation {
      a {
        word-break: keep-all;

        &:not(:last-child) {
          padding-right: 10px;
        }
      }
    }

    .dark-row {
      background-color: #f9f9f9;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/header/UseTable.vue